import { useTranslation } from 'react-i18next'
import { type LoaderFunctionArgs, useLoaderData } from 'react-router'
import { SignUpEmail } from '#app/components/email/sign-up.tsx'
import { requireControlsToBeEnabled } from '#app/utils/controls.server.ts'
import { getDomainUrl } from '#app/utils/misc.tsx'

export async function loader({ request }: LoaderFunctionArgs) {
  requireControlsToBeEnabled()

  const baseUrl = getDomainUrl(request)

  return { baseUrl }
}

export default function SignUpEmailPreviewRoute() {
  const { baseUrl } = useLoaderData<typeof loader>()

  const { t } = useTranslation()
  return (
    <>
      <SignUpEmail onboardingUrl="http://example.com" baseUrl={baseUrl} t={t} />
    </>
  )
}
